<template>
  <div class="guidelines-management">
    <div class="page-header">
      <div>
        <h1>Sumber Guidelines</h1>
      </div>
    </div>

    <div class="content-container">
      <div class="filters-section">
        <a-row :gutter="16">
          <a-col :xs="24" :sm="16" :md="20">
            <a-input
              v-model:value="searchQuery"
              placeholder="Cari nama sumber guideline"
              size="large"
              allow-clear
              @pressEnter="loadGuidelines"
            >
              <template #prefix>
                <SearchOutlined style="color: rgba(0, 0, 0, 0.25); margin-right: 4px" />
              </template>
            </a-input>
          </a-col>
          <a-col :xs="24" :sm="8" :md="4">
            <button class="tambah-button" @click="showCreateModal">
              <plus-outlined />
              TAMBAH
            </button>
          </a-col>
        </a-row>
      </div>

      <div class="table-card">
        <a-table
          :columns="columns"
          :data-source="guidelines"
          :loading="loading"
          :pagination="pagination"
          @change="handleTableChange"
          row-key="id"
          class="custom-table"
          :custom-row="customRow"
        >
          <template #no="{ index }">
            {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
          </template>

          <template #name="{ record }">
            <a
              @click="record.type === 'link' ? handleOpenLink(record.link) : goToSource(record)"
              class="source-link"
            >
              {{ record.name }}
            </a>
          </template>

          <template #type="{ record }">
            <a-tag :class="['type-tag', record.type === 'link' ? 'type-link' : 'type-content']">
              {{ record.type === 'link' ? 'Link' : 'Konten' }}
            </a-tag>
            <export-outlined
              @click.stop="handleOpenLink(record.link)"
              v-if="record.type === 'link'"
              class="ml-1 cursor-pointer"
            />
          </template>

          <template #status="{ record }">
            <div class="status-cell">
              <a-switch
                :checked="record.is_active"
                @change="checked => handleStatusChange(record, checked)"
                class="custom-switch"
                :class="{ 'switch-active': record.is_active }"
              />
              <a-tag class="type-tag status-tag">
                {{ record.is_active ? 'Aktif' : 'Nonaktif' }}
              </a-tag>
            </div>
          </template>

          <template #action="{ record }">
            <div class="action-buttons">
              <button class="btn-action-pill edit-btn" @click="showEditModal(record)">
                <edit-outlined /> UBAH
              </button>

              <button class="btn-action-pill delete-btn" @click="confirmDelete(record)">
                <delete-outlined /> HAPUS
              </button>
            </div>
          </template>
        </a-table>
      </div>
    </div>

    <!-- Create/Edit Modal -->
    <a-modal
      :title="modalTitle"
      v-model:visible="modalVisible"
      :confirm-loading="modalLoading"
      @cancel="handleModalCancel"
      :width="700"
      class="premium-modal"
      :footer="null"
    >
      <a-form :model="form" layout="vertical" ref="formRef" class="custom-form">
        <a-form-item
          name="name"
          :rules="[{ required: true, message: 'Nama sumber guideline wajib diisi' }]"
        >
          <template #label>
            <span>Nama Sumber Guideline <span style="color: #ff4d4f">*</span></span>
          </template>
          <a-input
            v-model:value="form.name"
            placeholder="Masukkan nama sumber guideline"
            size="large"
          />
        </a-form-item>

        <a-form-item
          name="type"
          :rules="[{ required: true, message: 'Jenis guideline wajib dipilih' }]"
        >
          <template #label>
            <span>Jenis Guideline <span style="color: #ff4d4f">*</span></span>
          </template>
          <a-radio-group v-model:value="form.type" class="custom-radio-group">
            <a-radio value="link">Link</a-radio>
            <a-radio value="content">Konten</a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item
          v-if="form.type === 'link'"
          name="link"
          :rules="[{ required: true, message: 'Link guideline wajib diisi' }]"
        >
          <template #label>
            <span>Link Guideline <span style="color: #ff4d4f">*</span></span>
          </template>
          <a-input v-model:value="form.link" placeholder="Masukkan link guideline" size="large" />
        </a-form-item>

        <!-- <a-form-item v-if="form.type !== 'content'" label="Logo" name="file"
                    :rules="[{ required: !editingGuideline && !form.currentFileUrl, message: 'Logo wajib diupload' }]">
                    <a-upload :before-upload="onBeforeUpload" :show-upload-list="true" :max-count="1" accept="image/*">
                        <button class="btn-upload-outline">
                            <upload-outlined /> UNGGAH
                        </button>
                        <div v-if="editingGuideline && form.currentFileUrl" class="mt-2 text-blue-500">
                            Logo saat ini sudah terupload. Upload baru akan mereplace logo lama.
                        </div>
                    </a-upload>
                </a-form-item> -->

        <a-form-item name="status">
          <template #label>
            <span>Status</span>
          </template>
          <div class="status-cell">
            <a-switch
              v-model:checked="form.is_active"
              class="custom-switch"
              :class="{ 'switch-active': form.is_active }"
            />
            <a-tag
              class="type-tag status-tag"
              :class="form.is_active ? 'status-active' : 'status-inactive'"
            >
              {{ form.is_active ? 'Aktif' : 'Nonaktif' }}
            </a-tag>
          </div>
        </a-form-item>

        <a-form-item class="mb-0 mt-8">
          <div class="d-flex justify-center modal-action-buttons">
            <button
              type="button"
              class="confirm-button"
              :disabled="modalLoading"
              @click="handleModalOk"
            >
              <span v-if="modalLoading" class="button-spinner"></span>
              {{ modalLoading ? 'MENYIMPAN...' : 'SIMPAN' }}
            </button>
            <button type="button" class="cancel-button" @click="handleModalCancel">KEMBALI</button>
          </div>
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- Dynamic Confirmation Modal -->
    <a-modal
      v-model:visible="confirmModalVisible"
      :title="confirmModalTitle"
      :footer="null"
      :closable="true"
      @cancel="confirmModalVisible = false"
      :width="450"
      :z-index="9999"
      class="premium-confirmation-modal"
    >
      <div class="confirm-content text-center">
        <p class="confirm-description">{{ confirmModalDescription }}</p>
        <div class="confirm-footer d-flex confirm-modal-action-buttons mt-8">
          <button class="btn-footer btn-confirm-cancel" @click="confirmModalVisible = false">
            KEMBALI
          </button>
          <button
            class="btn-footer btn-confirm-ok"
            :class="{ 'btn-danger': confirmModalType === 'delete' }"
            @click="handleConfirmOk"
          >
            {{ confirmModalOkText }}
          </button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { ref, reactive, computed, onMounted, h } from 'vue'
import { notification } from 'ant-design-vue'
import { CheckCircleOutlined } from '@ant-design/icons-vue'
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  ExportOutlined,
  SearchOutlined,
} from '@ant-design/icons-vue'
import { mobileCmsGuidelineAPI } from '@/services/axios/perki/mobileCms'

import { useRouter } from 'vue-router'

export default {
  name: 'MobileCmsGuidelineSources',
  components: {
    EditOutlined,
    DeleteOutlined,
    PlusOutlined,
    ExportOutlined,
    SearchOutlined,
  },
  setup() {
    const router = useRouter()
    const loading = ref(false)
    const guidelines = ref([])
    const searchQuery = ref('')
    const modalVisible = ref(false)
    const modalLoading = ref(false)
    const editingGuideline = ref(null)
    const formRef = ref(null)

    const form = reactive({
      name: '',
      type: 'content', // 'content' or 'link'
      url: '',
      file: null,
      currentFileUrl: '',
      is_active: true,
    })

    // Confirmation Modal State
    const confirmModalVisible = ref(false)
    const confirmModalType = ref('') // 'save', 'edit', 'delete'
    const confirmModalTarget = ref(null)

    const pagination = ref({
      current: 1,
      pageSize: 10,
      total: 0,
      showSizeChanger: true,
      showTotal: total =>
        `Menampilkan ${(pagination.value.current - 1) * pagination.value.pageSize +
          1} sampai ${Math.min(
          pagination.value.current * pagination.value.pageSize,
          total,
        )} dari ${total} baris`,
    })

    const columns = [
      {
        title: 'No.',
        key: 'no',
        slots: { customRender: 'no' },
      },
      {
        title: 'Nama Sumber Guidelines',
        dataIndex: 'name',
        key: 'name',
        slots: { customRender: 'name' },
        sorter: true,
      },
      {
        title: 'Jenis Guideline',
        key: 'type',
        slots: { customRender: 'type' },
        filters: [
          { text: 'Link', value: 'link' },
          { text: 'Konten', value: 'content' },
        ],
        filterMultiple: false,
      },
      {
        title: 'Status',
        key: 'status',
        slots: { customRender: 'status' },
      },
      {
        title: 'Aksi',
        key: 'action',
        slots: { customRender: 'action' },
        align: 'right',
      },
    ]

    const modalTitle = computed(() =>
      editingGuideline.value ? 'Ubah Sumber Guidelines' : 'Tambah Sumber Guidelines',
    )

    const confirmModalTitle = computed(() => {
      if (confirmModalType.value === 'delete') return 'Hapus data?'
      if (confirmModalType.value === 'edit') return 'Ubah data?'
      return 'Yakin isi formulir sudah sesuai?'
    })

    const confirmModalDescription = computed(() => {
      if (confirmModalType.value === 'delete')
        return 'Data yang dihapus tidak dapat dikembalikan. Apakah Anda yakin ingin melanjutkan?'
      if (confirmModalType.value === 'edit')
        return 'Mohon cek kembali perubahan data sebelum menyimpan formulir.'
      return 'Mohon cek kembali data sebelum menyimpan formulir.'
    })

    const confirmModalOkText = computed(() => {
      if (confirmModalType.value === 'delete') return 'YA, HAPUS'
      return 'YA, SIMPAN'
    })

    const showSuccessNotification = msg => {
      notification.success({
        message: 'Success',
        description: msg,
        placement: 'topRight',
        // icon: () => h(CheckCircleOutlined, { style: 'color: #10b981' }),
        class: 'premium-notification',
        duration: 3,
      })
    }

    // Using mock data temporarily if API fails
    const mockData = [
      {
        id: 1,
        name: 'PERKI - Perhimpunan Dokter Spesialis Kardiovaskular Indonesia',
        type: 'content',
        status: 'active',
      },
      {
        id: 2,
        name: 'AHA - American Heart Association',
        type: 'link',
        url: 'https://heart.org',
        status: 'active',
      },
      {
        id: 3,
        name: 'ACC - American College of Cardiology',
        type: 'link',
        url: 'https://acc.org',
        status: 'active',
      },
      {
        id: 4,
        name: 'BCS - British Cardiovascular Society',
        type: 'link',
        url: 'https://bcs.com',
        status: 'active',
      },
      {
        id: 5,
        name: 'CCS - Canadian Cardiovascular Society',
        type: 'link',
        url: 'https://ccs.ca',
        status: 'active',
      },
      {
        id: 6,
        name: 'ESC - European Society of Cardiology',
        type: 'link',
        url: 'https://esc.eu',
        status: 'inactive',
      },
    ]

    const loadGuidelines = async () => {
      loading.value = true
      try {
        const params = {
          page: pagination.value.current,
          page_size: pagination.value.pageSize,
        }
        if (searchQuery.value) params.search = searchQuery.value
        if (pagination.value.sortBy) params.sort_by = pagination.value.sortBy
        if (pagination.value.sortOrder) params.sort_order = pagination.value.sortOrder
        if (pagination.value.type) params.type = pagination.value.type

        const response = await mobileCmsGuidelineAPI.getSources(params)
        const result = response.data
        guidelines.value = result.data || []
        pagination.value.total = result.pagination?.total || guidelines.value.length
      } catch (error) {
        console.warn('API fetch failed, using mock data for UI demo', error)
        let filteredData = mockData
        if (searchQuery.value) {
          filteredData = mockData.filter(item =>
            item.name.toLowerCase().includes(searchQuery.value.toLowerCase()),
          )
        }
        guidelines.value = filteredData
        pagination.value.total = filteredData.length
      } finally {
        loading.value = false
      }
    }

    const handleTableChange = (pag, filters, sorter) => {
      pagination.value.current = pag.current
      pagination.value.pageSize = pag.pageSize

      // Handle Sorting
      if (sorter.field && sorter.order) {
        pagination.value.sortBy = sorter.field
        pagination.value.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
      } else {
        pagination.value.sortBy = null
        pagination.value.sortOrder = null
      }

      // Handle Filtering
      if (filters.type && filters.type.length > 0) {
        pagination.value.type = filters.type[0]
      } else {
        pagination.value.type = null
      }

      loadGuidelines()
    }

    const handleStatusChange = async (record, checked) => {
      const originalStatus = record.is_active
      record.is_active = checked

      try {
        const formData = new FormData()
        formData.append('is_active', checked)
        await mobileCmsGuidelineAPI.updateSource(record.id, formData)
        showSuccessNotification('Status berhasil diubah.')
      } catch (error) {
        record.is_active = originalStatus
        notification.error({ message: 'Error', description: 'Gagal mengubah status.' })
      }
    }

    const resetForm = () => {
      if (formRef.value) formRef.value.resetFields()
      form.name = ''
      form.type = 'content'
      form.link = ''
      form.file = null
      form.currentFileUrl = ''
      form.is_active = true
    }

    const showCreateModal = () => {
      editingGuideline.value = null
      resetForm()
      modalVisible.value = true
    }

    const showEditModal = record => {
      editingGuideline.value = record
      resetForm()
      form.name = record.name
      form.type = record.type
      form.link = record.link || ''
      form.is_active = record.is_active
      form.currentFileUrl = record.fileUrl || ''
      modalVisible.value = true
    }

    const handleModalCancel = () => {
      modalVisible.value = false
      editingGuideline.value = null
      resetForm()
    }

    const onBeforeUpload = file => {
      form.file = file
      return false // Prevent auto upload
    }

    const handleModalOk = async () => {
      try {
        await formRef.value.validate()
        confirmModalType.value = editingGuideline.value ? 'edit' : 'save'
        confirmModalVisible.value = true
      } catch {
        return
      }
    }

    const handleConfirmOk = async () => {
      if (confirmModalType.value === 'delete') {
        await deleteGuideline(confirmModalTarget.value)
        confirmModalVisible.value = false
        return
      }

      confirmModalVisible.value = false
      modalLoading.value = true
      try {
        const formData = new FormData()
        formData.append('name', form.name)
        formData.append('type', form.type)
        formData.append('link', form.link || '')
        formData.append('is_active', form.is_active)

        if (form.file) {
          formData.append('file', form.file)
        }

        if (editingGuideline.value) {
          await mobileCmsGuidelineAPI.updateSource(editingGuideline.value.id, formData)
          showSuccessNotification('Sumber guidelines berhasil diubah.')
        } else {
          await mobileCmsGuidelineAPI.createSource(formData)
          showSuccessNotification('Sumber guidelines berhasil ditambahkan.')
        }

        modalVisible.value = false
        loadGuidelines()
      } catch (error) {
        console.error('Submit failed:', error)
        notification.error({ message: 'Error', description: 'Gagal menyimpan data.' })
      } finally {
        modalLoading.value = false
      }
    }

    const confirmDelete = record => {
      confirmModalType.value = 'delete'
      confirmModalTarget.value = record
      confirmModalVisible.value = true
    }

    const deleteGuideline = async record => {
      try {
        await mobileCmsGuidelineAPI.deleteSource(record.id)
        showSuccessNotification('Sumber guidelines berhasil dihapus.')
        loadGuidelines()
      } catch (error) {
        notification.error({ message: 'Error', description: 'Gagal menghapus data.' })
      }
    }

    const goToSource = record => {
      router.push(`/mobile-cms/guidelines/${record.id}`)
    }

    const normalizeExternalUrl = link => {
      const raw = (link || '').trim()
      if (!raw) return null
      if (/^https?:\/\//i.test(raw)) return raw
      if (/^(?:www\.)?[a-z0-9-]+(?:\.[a-z0-9-]+)+(?:[/?#].*)?$/i.test(raw)) {
        return `https://${raw}`
      }
      return null
    }

    const handleOpenLink = link => {
      const normalizedLink = normalizeExternalUrl(link)

      if (!normalizedLink) {
        notification.error({
          message: 'Error',
          description: 'Link guideline tidak valid. Pastikan format URL benar.',
        })
        return
      }

      window.open(normalizedLink, '_blank')
    }

    const customRow = record => {
      return {
        onClick: event => {
          // Prevent navigation when clicking on recursive interactive elements
          const target = event.target
          if (
            target.tagName !== 'BUTTON' &&
            target.tagName !== 'A' &&
            target.tagName !== 'INPUT' &&
            !target.closest('button') &&
            !target.closest('.ant-switch') &&
            !target.closest('.action-buttons')
          ) {
            if (record.type !== 'link') {
              goToSource(record)
            } else {
              handleOpenLink(record.link)
            }
          }
        },
      }
    }

    onMounted(() => {
      loadGuidelines()
    })

    return {
      loading,
      guidelines,
      searchQuery,
      pagination,
      columns,
      modalVisible,
      modalLoading,
      editingGuideline,
      form,
      formRef,
      modalTitle,
      loadGuidelines,
      handleTableChange,
      handleStatusChange,
      showCreateModal,
      showEditModal,
      handleModalCancel,
      handleModalOk,
      handleConfirmOk,
      confirmDelete,
      deleteGuideline,
      onBeforeUpload,
      confirmModalVisible,
      confirmModalTitle,
      confirmModalDescription,
      confirmModalOkText,
      confirmModalType,
      goToSource,
      handleOpenLink,
      customRow,
    }
  },
}
</script>

<style lang="scss">
/* Global overrides for teleported modal content */
.premium-modal .ant-modal-title {
  font-size: 20px;
  font-weight: 700 !important;
  color: #111827;
}

.premium-confirmation-modal .ant-modal-title {
  font-size: 20px;
  font-weight: 700 !important;
  color: #111827;
}

.ant-modal-header {
  border-bottom: none !important;
  text-align: left;
  padding: 24px 24px 0px 24px !important;
}
</style>

<style lang="scss" scoped>
@import '../../styleViews.scss';

.guidelines-management {
  min-height: calc(100vh - 64px);
  background: #fcfcfc;

  @media (max-width: 768px) {
    padding: 4px;
  }

  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    border-radius: 8px;

    @media (max-width: 768px) {
      padding: 0;
    }

    h1 {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
      color: #282828;
    }
  }

  .content-container {
    border-radius: 8px;

    @media (max-width: 768px) {
      padding: 0;
    }

    .filters-section {
      margin-bottom: 24px;

      :deep(.ant-input::placeholder) {
        color: #999999 !important;
        opacity: 1 !important;
        font-size: 14px;
      }
    }
  }
}

.tambah-button {
  border-radius: 50px;
  font-size: 14px;
  font-weight: 700;
  border: 2px solid #e10f28;
  width: 100%;
  background: #e10f28;
  color: white;
  padding: 6px 12px;
  transition: all 0.3s;
  font-family: 'Barlow', sans-serif !important;

  @media (max-width: 576px) {
    margin-top: 12px;
  }

  &:hover {
    background: white !important;
    border-color: #e10f28 !important;
    color: #e10f28 !important;
  }
}

.table-card {
  overflow: hidden;
}

/* Table Aesthetics */
::v-deep(.ant-table-thead > tr > th) {
  background: #f2f4f8 !important;
  font-weight: 600;
  color: #262626;
  padding: 16px 24px;
  border-right: none !important;
  border-bottom: 1px solid #e5e7eb;
}

::v-deep(.ant-table) {
  border-collapse: collapse;
  font-size: 14px;
}

::v-deep(.ant-table-tbody > tr) {
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f5f5f5;
  }
}

::v-deep(.ant-table-bordered .ant-table-body > table) {
  border: none !important;
}

::v-deep(.ant-table-tbody > tr > td) {
  padding: 16px 24px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none !important;
  background: white !important;
}

::v-deep(.ant-table-tbody
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td) {
  background: #e4e9f0 !important;
}

::v-deep(.ant-table-tbody > tr > td.ant-table-column-sort) {
  background: white !important;
}

.type-tag {
  border-radius: 20px;
  padding: 4px 12px;
  font-weight: 400;
  border: 0.5px solid;
  font-size: 12px;
}

.cursor-pointer {
  cursor: pointer;
  color: #e10f28;
}

.type-content {
  background: #eff6ff;
  color: #0957d9;
  border-color: #91caff;
}

.type-link {
  background: #faf5ff;
  color: #541cab;
  border-color: #d2adf7;
}

.status-tag {
  border-color: #d9d9d9;
  background: #fafafa;
  color: #183e6f;
}

/* Status cell specifically */
.status-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.status-text {
  font-size: 14px;
  color: #9ca3af;
  font-weight: 500;
}

.text-active {
  color: #3b82f6;
  /* Blue text for active state */
}

/* Custom Switch Styling matching Mockup */
:deep(.custom-switch.ant-switch) {
  background-color: #d1d5db;
  /* Gray when inactive */
}

:deep(.custom-switch.switch-active.ant-switch) {
  background-color: #dc2626;
  /* Red when active */
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.confirm-modal-action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.btn-action-pill {
  height: 32px;
  padding: 0 16px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  background: white;
  transition: all 0.2s;
}

.edit-btn {
  border: 2px solid var(--E-Office-Secondary, #282828);
  color: #282828;

  &:hover {
    border-color: #9ca3af;
    background: #f9fafb;
  }
}

.delete-btn {
  background: #1f2937;
  border: 1px solid #1f2937;
  color: white;

  &:hover {
    background: #374151;
    border-color: #374151;
  }
}

/* Pagination Styling */
:deep(.ant-pagination) {
  padding: 16px 24px;
  margin: 0 !important;
  border-top: 1px solid #f3f4f6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

:deep(.ant-pagination-total-text) {
  color: #6b7280;
  flex: 1;
  text-align: left;
}

/* Modal form overrides */
.premium-modal {
  position: relative;
}

.premium-modal :deep(.ant-modal-close-x) {
  font-size: 18px;
}

.custom-form :deep(.ant-form-item) {
  margin-bottom: 24px;
}

.custom-form :deep(label.ant-form-item-required) {
  margin-bottom: 0 !important;
  font-weight: 600;
}

.custom-form :deep(.ant-form-item-label > label) {
  font-weight: 600;
  color: #374151;
}

.custom-form :deep(.ant-form-item-label > label::after),
.custom-form :deep(.ant-form-item-label > label.ant-form-item-required::before),
.custom-form :deep(.ant-form-item-label > label.ant-form-item-required::after) {
  display: none !important;
  content: none !important;
}

.premium-modal :deep(.ant-input) {
  border-radius: 8px;
  border-color: #d1d5db;
  font-size: 14px;
}

:deep(.ant-input::placeholder) {
  color: #798892 !important;
  opacity: 1 !important;
}

.custom-radio-group :deep(.ant-radio-wrapper) {
  margin-right: 24px;
  font-size: 14px;
  align-items: center;
}

.custom-radio-group {
  display: flex;
  margin-top: 8px;

  @media (max-width: 714px) {
    flex-direction: column;
    gap: 8px;
  }
}

.custom-radio-group :deep(.ant-radio-checked .ant-radio-inner) {
  border-color: #dc2626;
}

.custom-radio-group :deep(.ant-radio-inner::after) {
  background-color: #dc2626;
}

.btn-upload-outline {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 24px;
  border-radius: 20px;
  border: 2px solid #dc2626;
  background: white;
  color: #dc2626;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #fef2f2;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.modal-action-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.cancel-button {
  max-width: 230px;
  background: #ffffff;
  border: 2px solid #1a1a1a;
  color: #1a1a1a;
  border-radius: 50px;
  padding: 6px 16px;
  font-size: 14px;
  font-weight: 700;
  font-family: 'Barlow' !important;
  cursor: pointer;
  transition: all 0.3s;
  height: 40px;

  &:hover {
    background: #1a1a1a;
    color: white;
  }
}

.confirm-button {
  border-radius: 50px;
  font-size: 14px;
  font-weight: 700;
  border: 2px solid #e10f28;
  max-width: 150px;
  background: #e10f28;
  color: white;
  padding: 6px 16px;
  transition: all 0.3s;
  height: 40px;
  line-height: 1.5;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: 'Barlow' !important;

  @media (max-width: 768px) {
    width: 100%;
  }

  &:hover:not(:disabled) {
    background: white;
    border-color: #e10f28;
    color: #e10f28;
  }

  &:disabled {
    border-color: #98a2b3;
    background: #98a2b3;
    color: white;
    cursor: not-allowed;
    opacity: 0.8;
  }

  .button-spinner {
    width: 14px;
    height: 14px;
    border: 2px solid #ffffff;
    border-top: 2px solid transparent;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }
}

.source-link {
  color: #444444;
  font-weight: 400;
  transition: color 0.2s;

  &:hover {
    color: #dc2626;
  }
}

.confirm-description {
  font-size: 16px;
  color: #4b5563;
  text-align: left;
  margin-bottom: 28px;
}

.btn-confirm-cancel {
  padding: 8px 20px;
  border-radius: 24px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;

  align-items: center;
  justify-content: center;
  background: white;
  border: 1px solid #111827;
  color: #111827;

  &:hover {
    background: #111827;
    border: 1px solid #111827;
    color: white;
  }
}

.btn-confirm-ok {
  padding: 8px 20px;
  border-radius: 24px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;

  align-items: center;
  justify-content: center;
  background: #dc2626;
  color: white;
  border: 1px solid $primary;

  &:hover {
    background: transparent;
    color: $primary;
    border: 1px solid $primary;
  }
}

/* Notification Styling */
:deep(.premium-notification) {
  border-radius: 12px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);

  .ant-notification-notice-message {
    font-weight: 700;
    margin-bottom: 4px;
  }

  .ant-notification-notice-description {
    font-size: 14px;
    color: #4b5563;
  }

  .ant-notification-notice-close {
    top: 16px;
    right: 16px;
  }
}
</style>
